var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 3H18.3C18.5387 3 18.7676 3.09482 18.9364 3.2636C19.1052 3.43239 19.2 3.66131 19.2 3.9V21.1287C19.2001 21.2092 19.1786 21.2882 19.1378 21.3575C19.097 21.4269 19.0383 21.484 18.9679 21.523C18.8975 21.5619 18.818 21.5813 18.7375 21.5791C18.6571 21.5769 18.5787 21.5531 18.5106 21.5103L12 17.427L5.4894 21.5094C5.42133 21.5522 5.34305 21.5759 5.26269 21.5782C5.18234 21.5805 5.10284 21.5612 5.03247 21.5223C4.9621 21.4834 4.90342 21.4264 4.86254 21.3572C4.82166 21.288 4.80006 21.2091 4.8 21.1287V3.9C4.8 3.66131 4.89482 3.43239 5.06361 3.2636C5.23239 3.09482 5.46131 3 5.7 3Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFill);
export default __webpack_public_path__ + "static/media/bookmark-fill.938049fea0ab43e5bb006f41e1cee5b2.svg";
export { ForwardRef as ReactComponent };